import PropTypes from 'prop-types'
import Modal, { ModalBody, ModalHeader } from '../../../common/Modal'
import HarnessForm from './HarnessForm'

const CreateUpdateHarness = (props) => {
  return (
    <Modal
      onClose={() => {
        props.setShowModal(false)
      }}
      show={props.showModal}
    >
      <ModalHeader className={'text-white'}>
        Update Existing Harness
      </ModalHeader>
      <ModalBody>
        <HarnessForm
          onSave={() => {
            props.setShowModal(false)
          }}
        />
      </ModalBody>
    </Modal>
  )
}

CreateUpdateHarness.propTypes = {
  setShowModal: PropTypes.func.isRequired,
  showModal: PropTypes.bool.isRequired,
}

export default CreateUpdateHarness
